import { defineStore } from "pinia";
import { DefaultService as api } from "@/client";
import _ from "lodash";

export const useStore = defineStore("main", {
  state: () => {
    return {
      projects: [] as any[],
      modelProviders: [] as any[],
      fetchedModelProviders: false,
      models: {
        "Open AI": [
          "gpt-3.5-turbo",
          "gpt-3.5-turbo-1106",
          "gpt-4",
          "gpt-4-0613",
          "gpt-4-32k-0613",
          "gpt-4-1106-preview",
          "Custom model",
        ],
        "AWS Bedrock": [
          "anthropic.claude-v2",
          "anthropic.claude-instant-v1",
          "anthropic.claude-v1",
          "amazon.titan-text-lite-v1",
          "amazon.titan-text-express-v1",
          "cohere.command-text-v14",
          "ai21.j2-mid-v1",
          "ai21.j2-ultra-v1",
          "meta.llama2-13b-chat-v1",
          "meta.llama2-70b-chat-v1",
          "Custom model",
        ],
        "Azure Open AI": ["Custom deployment name"],
        Anthropic: [
          "claude-2.1",
          "claude-2",
          "claude-instant-1",
          "claude-instant-1.2",
          "Custom model",
        ],
        AI21: ["j2-light", "j2-mid", "j2-ultra", "Custom model"],
        "Aleph Alpha": [
          "luminous-base",
          "luminous-base-control",
          "luminous-extended",
          "luminous-extended-control",
          "luminous-supreme",
          "luminous-supreme-control",
          "Custom model",
        ],
        Google: [
          "gemini-pro",
          "chat-bison",
          "chat-bison-001",
          "text-bison",
          "text-bison-001",
          "text-bison-safety-off",
          "text-bison-safety-recitation-off",
          "Custom model",
        ],
        Anyscale: [
          "mistralai/Mixtral-8x7B-Instruct-v0.1",
          "mistralai/Mistral-7B-Instruct-v0.1",
          "HuggingFaceH4/zephyr-7b-beta",
          "meta-llama/Llama-2-7b-chat-hf",
          "meta-llama/Llama-2-13b-chat-hf",
          "meta-llama/Llama-2-70b-chat-hf",
          "Meta-Llama/Llama-Guard-7b",
          "codellama/CodeLlama-34b-Instruct-hf",
          "Custom model",
        ],
        Together: [
          "togethercomputer/llama-2-7b-chat",
          "togethercomputer/llama-2-13b-chat",
          "togethercomputer/llama-2-70b-chat",
          "mistralai/Mistral-7B-Instruct-v0.1",
          "mistralai/Mistral-7B-Instruct-v0.2",
          "mistralai/Mixtral-8x7B-Instruct-v0.1",
          "Meta-Llama/Llama-Guard-7b",
          "Custom model",
        ],
      },
      // modelPrefixByProvider: {
      //   "Open AI": "",
      //   "AWS Bedrock": "",
      //   "Azure Open AI": "azure/",
      //   Anthropic: "",
      //   AI21: "",
      //   "Aleph Alpha": "",
      //   Google: "palm/",
      // },
      notifications: [] as Notification[],
      side: {
        show: false,
        type: undefined as
          | "prompt-version"
          | "log"
          // | "test-execution"
          | "evaluation"
          | "test-case"
          | "eval-config"
          | "docs"
          | "check"
          | "column-config"
          | undefined,
        data: undefined as any,
      },
      hasSecretKeyStored: true,
      event: null,
    };
  },

  actions: {
    addNotification(notification: Notification) {
      this.notifications.push(notification);

      setTimeout(
        () => {
          this.notifications.shift();
        },
        notification.message?.length > 100 ? 10000 : 5000
      );
    },

    displayColumnConfig(data) {
      this.side.show = false;
      this.side.show = true;
      this.side.type = "column-config";
      this.side.data = { data };
    },

    displayPromptVersion(promptId, promptVersionId) {
      this.side.show = false;
      this.side.show = true;
      this.side.type = "prompt-version";
      this.side.data = { promptId: promptId, promptVersionId: promptVersionId };
    },

    displayTestCase(data) {
      this.side.show = false;
      this.side.show = true;
      this.side.type = "test-case";
      this.side.data = data;
    },

    displayEvaluation(data) {
      this.side.show = false;
      this.side.show = true;
      this.side.type = "evaluation";
      this.side.data = data;
    },

    displayLog(executionId) {
      this.side.show = false;
      this.side.show = true;
      this.side.type = "log";
      this.side.data = { executionId: executionId };
    },

    displayEvalConfig() {
      this.side.show = false;
      this.side.show = true;
      this.side.type = "eval-config";
      this.side.data = {};
    },

    displayDocs(topic: string) {
      this.side.show = false;
      this.side.show = true;
      this.side.type = "docs";
      this.side.data = { topic: topic };
    },

    displayCheck(checkData) {
      this.side.show = false;
      this.side.show = true;
      this.side.type = "check";
      this.side.data = checkData;
    },

    closeSide() {
      this.side.show = false;
      // this.side.type = undefined;
      this.side.data = undefined;
      // console.log("close side", this.side);
    },

    // called after side panel "leave" transition is done
    closeSideFull() {
      this.side.show = false;
      this.side.type = undefined;
      this.side.data = undefined;
    },

    triggerEvent(eventData) {
      this.event = eventData;
    },

    async fetchProjects() {
      api.readPromptsByOrg().then((prompts) => {
        this.projects = _.sortBy(
          prompts.map((prompt) => {
            return {
              label: prompt.name,
              value: prompt.id,
            };
          }),
          "label"
        );
      });
    },

    async fetchModelProviders() {
      // console.log("fetching");
      this.fetchedModelProviders = false;
      return api.readSecretsByOrg().then((secrets) => {
        this.modelProviders = _.uniq(
          secrets
            .map((secret) => {
              return secret.secret_metadata?.name;
            })
            .filter((name) => name != undefined)
        );
        this.fetchedModelProviders = true;
      });
    },
  },
});

interface Notification {
  title: string;
  message: string;
  sentiment: "positive" | "negative" | "neutral";
}
